export default function getIndexForCompetitorId(competitorsList, id) {
  let result = -1;

  competitorsList.some((competitor, index) => {
    if (parseInt(competitor.hotelinfo?.id, 10) === parseInt(id, 10)) {
      result = index;
      return true;
    }
    return false;
  });

  return result;
}
